$(function () {
    const WorksFilterForm = function () {
        this.init = function ($el) {
            $el.autocomplete({"source": "\/api\/service-list", "minLength": 0});
        }
    };

    const $form = $('[name=worksFilterService]');

    if ($form.length > 0) {
        (new WorksFilterForm).init($form);
    }
});
